import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import classNames from 'classnames/bind';
import { selectIrisSeoMeta } from '../../selectors/IrisPageSelector';
import { selectCMSeoMeta } from '../../selectors/CMPageSelector';
import * as styles from './PageTitle.css';

const cx = classNames.bind(styles);

const getPageTitle = (h1tag, enableTextTransform, title) => {
    const textTransformSwap = enableTextTransform
        ? cx('enableTextTransform')
        : cx('disableTextTransform');
    const h1TextWithCaseChange = enableTextTransform ? h1tag.toLowerCase() : h1tag;
    return title !== 'COUPONTITLE' ? (
        <div className={cx('title')}>
            <h1 className={cx('hTitle', textTransformSwap)} data-automation-id="headerTag">
                {h1TextWithCaseChange}
            </h1>
        </div>
    ) : (
        <div className={cx('title')}>
            <h1 className={cx('couponTitle', textTransformSwap)} data-automation-id="headerTag">
                {h1TextWithCaseChange}
            </h1>
        </div>
    );
};

export const PageTitle = (props) => {
    const {
        seoTags: { content = {}, h1Tag = '' },
        enableTextTransform,
        isCMPageEnabled,
        title,
    } = props;
    const pageTitle = isCMPageEnabled ? h1Tag : content.h1Tag;
    if (pageTitle) {
        return getPageTitle(pageTitle, enableTextTransform, title);
    }
    return null;
};

PageTitle.defaultProps = {
    seoTags: { content: {}, h1Tag: '' },
    enableTextTransform: true,
    title: '',
};
PageTitle.propTypes = {
    seoTags: PropTypes.oneOfType([PropTypes.object]),
    enableTextTransform: PropTypes.bool,
    title: PropTypes.bool,
};

const mapStateToProps = (store, ownProps) => {
    const { isCMPageEnabled } = ownProps;
    const seoMetaData = isCMPageEnabled ? selectCMSeoMeta(store) : selectIrisSeoMeta(store);
    return {
        seoTags: seoMetaData,
        enableTextTransform: _get(store, 'context.featureFlags.enableTextTransform', false),
    };
};

export default connect(mapStateToProps)(PageTitle);
